module.exports = "<p>\r\n  ex-notifications-action works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/auth/signin/ex-notifications-action/ex-notifications-action.component.html
// module id = ../../../../../src/app/auth/signin/ex-notifications-action/ex-notifications-action.component.html
// module chunks = main